import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36920032"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-wrap items-center justify-center" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "br16 p-2" }
const _hoisted_4 = { class: "flex justify-left items-center ml-6 mr-6" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_7 = {
  key: 1,
  class: "mr-2"
}
const _hoisted_8 = {
  key: 2,
  class: "mr-2"
}
const _hoisted_9 = {
  key: 3,
  class: "mr-2"
}
const _hoisted_10 = {
  key: 4,
  class: "mr-2"
}
const _hoisted_11 = {
  key: 5,
  class: "mr-2"
}
const _hoisted_12 = {
  key: 6,
  class: "mr-2"
}
const _hoisted_13 = {
  key: 1,
  class: "flex"
}
const _hoisted_14 = { class: "mr-2" }
const _hoisted_15 = { class: "mr-2" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 2,
  class: "mt-1 mb-1 text-xs custom-gradient ml-auto"
}
const _hoisted_19 = {
  key: 0,
  class: "flex justify-between ml-6 mr-6"
}
const _hoisted_20 = { class: "flex items-center text-xs" }
const _hoisted_21 = { class: "flex justify-between ml-6 mr-6" }
const _hoisted_22 = { class: "flex items-center text-xs" }
const _hoisted_23 = { class: "flex justify-between ml-6 mr-6" }
const _hoisted_24 = {
  key: 0,
  class: "mt-1 mb-1 text-xs"
}
const _hoisted_25 = {
  key: 1,
  class: "flex overflow-hidden min-h-176"
}
const _hoisted_26 = { class: "w-full flex justify-center mb-4" }
const _hoisted_27 = { class: "flex flex-col" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divisor mr-4 ml-4 bg-white br16" }, null, -1))
const _hoisted_29 = { class: "flex flex-col" }
const _hoisted_30 = { class: "flex text-xs items-center ml-6 mr-6" }
const _hoisted_31 = { class: "custom-gradient mr-2" }
const _hoisted_32 = {
  key: 0,
  class: "ml-auto"
}
const _hoisted_33 = {
  key: 1,
  class: "ml-auto"
}
const _hoisted_34 = { class: "error_color" }
const _hoisted_35 = { class: "flex p-6 justify-around" }
const _hoisted_36 = { class: "mt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgContainer = _resolveComponent("SvgContainer")!
  const _component_MatchTeam = _resolveComponent("MatchTeam")!
  const _component_BorderButton = _resolveComponent("BorderButton")!
  const _component_PopUpLight = _resolveComponent("PopUpLight")!
  const _component_UserGenderSelector = _resolveComponent("UserGenderSelector")!
  const _directive_disable_on_click = _resolveDirective("disable-on-click")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "flex flex-col items-center main-container",
      style: _normalizeStyle({
      paddingTop: 'var(--safe-area-inset-top)',
      paddingBottom: 'var(--safe-area-inset-bottom)',
    })
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.matches, (match) => {
          return (_openBlock(), _createElementBlock("div", {
            key: match.id,
            class: _normalizeClass(["mr-2 ml-2 flex", {'opacity-50 pointer-events-none': match.canJoin==false}])
          }, [
            _createElementVNode("div", {
              class: "myMatchesClue mt-2 mb-2 cursor-pointer",
              onClick: ($event: any) => (_ctx.goToJoin(match))
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  (_ctx.showSport)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        (match.sport?.code == _ctx.sport.PADEL)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              _createVNode(_component_SvgContainer, {
                                name: _ctx.SportIconNames.PADEL
                              }, null, 8, ["name"])
                            ]))
                          : _createCommentVNode("", true),
                        (match.sport?.code == _ctx.sport.TENIS)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createVNode(_component_SvgContainer, {
                                name: _ctx.SportIconNames.TENIS
                              }, null, 8, ["name"])
                            ]))
                          : _createCommentVNode("", true),
                        (match.sport?.code == _ctx.sport.PICKLEBALL)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              _createVNode(_component_SvgContainer, {
                                name: _ctx.SportIconNames.PICKLEBALL
                              }, null, 8, ["name"])
                            ]))
                          : _createCommentVNode("", true),
                        (match.sport?.code == _ctx.sport.SOCCER)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _createVNode(_component_SvgContainer, {
                                name: _ctx.SportIconNames.SOCCER
                              }, null, 8, ["name"])
                            ]))
                          : _createCommentVNode("", true),
                        (match.sport?.code == _ctx.sport.PADBOL)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createVNode(_component_SvgContainer, {
                                name: _ctx.SportIconNames.PADBOL
                              }, null, 8, ["name"])
                            ]))
                          : _createCommentVNode("", true),
                        (match.sport?.code == _ctx.sport.RACQUETBALL)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createVNode(_component_SvgContainer, {
                                name: _ctx.SportIconNames.RACQUETBALL
                              }, null, 8, ["name"])
                            ]))
                          : _createCommentVNode("", true),
                        (match.sport?.code == _ctx.sport.SQUASH)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _createVNode(_component_SvgContainer, {
                                name: _ctx.SportIconNames.SQUASH
                              }, null, 8, ["name"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (match.type?.code === _ctx.bookingType.MATCH)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_SvgContainer, { name: "pentaIcon" })
                        ]),
                        _createElementVNode("div", _hoisted_15, _toDisplayString(match.minLevel?.toFixed(2)) + "-" + _toDisplayString(match.maxLevel?.toFixed(2)), 1),
                        (
                    match.levelProvider &&
                    match.levelProvider.code == _ctx.LevelProvider.REDPADEL
                  )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _createElementVNode("img", {
                                src: _ctx.redPadelIcon,
                                class: "icon"
                              }, null, 8, _hoisted_17)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (match.type?.code === _ctx.bookingType.MATCH)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(match.competitive
                    ? _ctx.addThreeDotsText(_ctx.$t("competitive"))
                    : _ctx.addThreeDotsText(_ctx.$t("friendly"))), 1))
                    : _createCommentVNode("", true)
                ]),
                (match.type?.code === _ctx.bookingType.MATCH)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", null, _toDisplayString(_ctx.$t("gender") +
                    " " +
                    _ctx.$t(_ctx.getGender(Number(match.gender?.code))).toLowerCase()), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.getDate(match) + " " + match.duration + " " + _ctx.$t("min")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  (match.tenant)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.capitalizeFirstLetter(match.tenant?.name!)), 1))
                    : _createCommentVNode("", true)
                ]),
                (!_ctx.isSoccer(match))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createVNode(_component_MatchTeam, {
                            match: (match as Booking),
                            team: 0
                          }, null, 8, ["match"])
                        ]),
                        _hoisted_28,
                        _createElementVNode("div", _hoisted_29, [
                          _createVNode(_component_MatchTeam, {
                            match: (match as Booking),
                            team: 1
                          }, null, 8, ["match"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.getPrice(match)), 1),
                  (
                  match.status?.code === _ctx.bookingStatus.BOOKED ||
                  match.status?.code === _ctx.bookingStatus.FINISHED
                )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32))
                    : _createCommentVNode("", true),
                  (match.status?.code === _ctx.bookingStatus.CANCELED)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.addThreeDotsText(_ctx.$t("cancelled"))), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 8, _hoisted_2)
          ], 2))
        }), 128))
      ]),
      (_ctx.showButton)
        ? _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createMatchClicked($event))),
            class: "createMatch p-4 br60 cursor-pointer"
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t("create_match")), 1)
          ])), [
            [_directive_disable_on_click, void 0, "create-match-availability"]
          ])
        : _createCommentVNode("", true)
    ], 4),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (_ctx.showCreateMatchPopup)
          ? (_openBlock(), _createBlock(_component_PopUpLight, {
              key: 0,
              showOkButton: false,
              onClosed: _ctx.closeCreateMatchPopup
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_component_BorderButton, {
                    onClicked: _ctx.createMatchInTaykus,
                    text: _ctx.$t('in_a_taykus_club')
                  }, null, 8, ["onClicked", "text"]),
                  _createVNode(_component_BorderButton, {
                    onClicked: _ctx.createMatchNotInTaykus,
                    text: _ctx.$t('i_allready_have_a_court')
                  }, null, 8, ["onClicked", "text"])
                ])
              ]),
              _: 1
            }, 8, ["onClosed"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (!_ctx.hasGender)
          ? (_openBlock(), _createBlock(_component_PopUpLight, {
              key: 0,
              showClose: false
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_36, [
                  _createVNode(_component_UserGenderSelector, { onSelectionChanged: _ctx.saveGenderChanges }, null, 8, ["onSelectionChanged"])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}